/**
 * Copyright © 2022-2023 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

const YYYY_MM_DD = 'YYYY-MM-DD'
const YYYY_MM = 'YYYY-MM'
const MM_DD = 'MM-DD'
const DD_MM_YY = 'DD/MM/YY'
const MM_DD_YY = 'MM/DD/YY'
const MM_DD_YYYY = 'MM/DD/YYYY'
const MM_DD_YYYY_H_MM_A = 'MM/DD/YYYY h:mm A'
const MMM_YYYY_TEXT = 'MMM YYYY'
const YYYY_TEXT = 'YYYY'
const MMMM_D_YYYY = 'MMMM D, YYYY'

export const DateTimeConstants = {
  THIRTY_DAYS: 30,
  TWO_WEEKS: 14,
  WEEK_DAYS: 7,
  MONTHS_IN_YEAR: 12,
  DAYS_IN_YEAR: 365,
  SIXTY_DAYS: 60,
  HOURS_DAY: 24,
  YYYY_MM_DD,
  YYYY_MM,
  MM_DD,
  DD_MM_YY,
  MM_DD_YY,
  MMM_YYYY_TEXT,
  YYYY_TEXT,
  MM_DD_YYYY,
  MMMM_D_YYYY,
  MM_DD_YYYY_H_MM_A,
}

export const THIRTY_DAYS = 'Past 30 Days vs Prev. 30 Days'
export const NINETY_DAYS = 'Past 90 Days vs Prev. 90 Days'
export const SIX_MONTHS = 'Past 6 Months vs Prev. 6 Months'
export const TWELVE_MONTHS = 'Past 12 Months vs Prev. 12 Months'
export const THIRTY_DAYS_YOY = 'Past 30 Days Year-over-Year'
export const THIRTY_DAYS_VALUE_UNIQUE =
  String(DateTimeConstants.THIRTY_DAYS) + '.0'
